import { Flickfusion } from 'client/site-modules/shared/components/flickfusion/flickfusion';
import { SpinCar } from 'site-modules/shared/components/spin-car/spin-car';

export const CARMAX = 'CARMAX';
export const SPINCAR = 'SPINCAR';

export const PROVIDER_360 = {
  CARMAX: {},
  SPINCAR: {
    component: SpinCar,
    tracking: { parentTrackingId: 'spincar-360-indication', creativeId: 'edm-entry-spincar-360' },
  },
  FLICKFUSION: {
    component: Flickfusion,
    tracking: { parentTrackingId: 'flickfusion-360-indication', creativeId: 'edm-entry-flickfusion-360' },
  },
};
